export const SPACING = '1.4285714285714286rem';
export const SPACING_DESKTOP = '3.357142857142857rem';

export const COLOR_BLUE = '#64C3E0';

export const MAX_WIDTH = '1024px';

export const MOBILE = '425px';
export const TABLET = '768px';
export const DESKTOP = '1024px';